var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 5.212V1.519h1.5v3.693zm6.073 2.519-1.029-1.029 2.579-2.663 1.063 1.078zm1.465 5.019v-1.5h3.693v1.5zm-7.538 9.73v-3.682h1.5v3.683zM6.696 7.69 4.04 5.128l1.088-1.054 2.614 2.604zm12.162 12.272-2.564-2.664 1.014-1.004 2.619 2.548zM1.519 12.75v-1.5h3.693v1.5zm3.598 7.212-1.044-1.089 2.579-2.579.542.512.552.527zm6.885-2.462q-2.29 0-3.896-1.604T6.5 12.003t1.604-3.896Q9.708 6.5 11.998 6.5q2.29 0 3.896 1.604t1.606 3.894-1.604 3.896Q14.293 17.5 12.003 17.5M12 16q1.65 0 2.825-1.175T16 12t-1.175-2.825T12 8 9.175 9.175 8 12t1.175 2.825T12 16"
  })));
};
export default SvgSun;